<template>
  <div class="catalog-public">
    <!-- Шапка: логотип ЛК + ссылки на официальные сервисы,
         контент в той же колонке 1284px, что и у футера -->
    <header class="catalog-public__topbar">
      <div class="catalog-public__topbar-inner">
        <router-link to="/podbor">
          <Logo class="login-inner__logo" />
        </router-link>
        <nav class="catalog-public__nav">
          <a
            href="https://www.stone-xxi.ru/"
            target="_blank"
            rel="noopener"
            class="d-none d-md-inline"
            >Официальный сайт</a
          >
          <a
            href="https://www.stone-xxi.ru/calculator/"
            target="_blank"
            rel="noopener"
            class="d-none d-md-inline"
            >Калькулятор</a
          >
          <RouterLink
            class="btn btn-base"
            to="/"
            target="_blank"
            rel="noopener"
            >Личный кабинет</RouterLink
          >
        </nav>
      </div>
    </header>

    <main class="catalog-public__main">
      <!-- Табы разделов: каталог / произвольная заявка.
           Подчёркивание — как у навигации на странице входа (login-hr) -->
      <div class="catalog-public__container">
        <div class="catalog-public__tabs">
          <RouterLink exact-active-class="active" to="/podbor">
            <div class="catalog-public__tab-title">Техника из каталога</div>
            <div class="catalog-public__tab-hr"></div>
          </RouterLink>
          <RouterLink exact-active-class="active" to="/podbor/application">
            <div class="catalog-public__tab-title">Произвольная заявка</div>
            <div class="catalog-public__tab-hr"></div>
          </RouterLink>
        </div>
      </div>

      <slot />
    </main>

    <!-- Футер: логотип + ссылки на официальные сервисы -->
    <footer class="catalog-public__footer">
      <div class="catalog-public__footer-inner">
        <Logo class="login-inner__logo" />
        <p class="mb-0">Цены и условия требуют подтверждения у менеджера.</p>
        <!-- Класс на ссылках обязателен: глобальный a:not([class])
             из шаблонных стилей иначе возвращает подчёркивание -->
        <div class="catalog-public__footer-links">
          <a
            class="catalog-public__footer-link"
            href="https://www.stone-xxi.ru/"
            target="_blank"
            rel="noopener"
            >Официальный сайт</a
          >
          <a
            class="catalog-public__footer-link"
            href="https://www.stone-xxi.ru/calculator/"
            target="_blank"
            rel="noopener"
            >Калькулятор</a
          >
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import Logo from "@/assets/svg/Logo.vue";

import "./style.css";

export default {
  name: "catalog-public-layout",
  components: { Logo },
};
</script>
